export enum SizeTokensEnum {
    XS = "XS",
    S = "S",
    M = "M",
    L = "L",
    XL = "XL"
}
